const map = {
	"./0-stars-white.png": 13945,
	"./0-stars.png": 49821,
	"./1-stars-white.png": 40596,
	"./1-stars.png": 88148,
	"./2-stars-white.png": 1963,
	"./2-stars.png": 93787,
	"./3-stars-white.png": 894,
	"./3-stars.png": 14570,
	"./6405f757ecff7c0014c70608.png": 25101,
	"./646b899e8223ca0014758fab.png": 69227,
	"./65dbefd7e65fa30015b1b10e.png": 61109,
	"./65f85f08065c76001555e7a9.png": 8646,
	"./66eae61738b1260015d7a9d3.png": 78700,
	"./670ce2a2654a4d0015812d5f.png": 1661,
	"./67dc1d1de1924600157cd149.png": 94478,
	"./Akanthas-logo-RVB.png": 26759,
	"./Ampliroll.png": 34807,
	"./BigBag.png": 10141,
	"./Chain.png": 85166,
	"./Compactor.png": 3017,
	"./DropOff.png": 83439,
	"./Folder-rafiki 1.png": 83425,
	"./Geobox.png": 18655,
	"./HwCharacZone.png": 49748,
	"./IntermediateBulkContainer.png": 88469,
	"./LatticeBox.png": 22020,
	"./Lego.png": 78082,
	"./MetallicDrum.png": 97190,
	"./OldAmpliroll.png": 95178,
	"./PickUp.png": 45633,
	"./PlasticDrum.png": 5997,
	"./StorageArea.png": 2477,
	"./Tone.png": 25485,
	"./Unknown.png": 4371,
	"./UploadFileFilled.png": 97292,
	"./bulb.png": 3352,
	"./campaign-export.png": 97628,
	"./campaign-list.png": 77526,
	"./caracterisation.png": 98099,
	"./close-icon.png": 62687,
	"./decheterie.png": 43289,
	"./en.png": 6776,
	"./es.png": 44365,
	"./excavator.png": 44274,
	"./excavatorGrey.png": 33895,
	"./excavatorRed.png": 78365,
	"./fr.png": 78165,
	"./freepik--Plastic--inject-1.png": 18358,
	"./freepik--garbage-bag--inject-372.png": 15163,
	"./image_plus.png": 68819,
	"./logo-akanthas.png": 17006,
	"./logo-black.png": 5226,
	"./logo.png": 16940,
	"./logoHeader.png": 95859,
	"./logo_rvg.png": 3114,
	"./logo_rvg_white.png": 22944,
	"./mascot-1.png": 76966,
	"./mascot-2.png": 60733,
	"./noInput.png": 68006,
	"./sample-activity-en.png": 28161,
	"./sample-activity-fr.png": 87612,
	"./sample-caracteristic-en.png": 51513,
	"./sample-caracteristic-fr.png": 69700,
	"./sample-characterizarion-en.png": 21503,
	"./sample-characterizarion-fr.png": 71198,
	"./sample-containers-en.png": 52936,
	"./sample-containers-fr.png": 78949,
	"./sample-report-en.png": 88470,
	"./sample-report-fr.png": 3567,
	"./sample-weight-en.png": 51552,
	"./sample-weight-fr.png": 82541,
	"./se.png": 16749,
	"./user.png": 43612,
	"./wasteQualityHeader.png": 52223,
	"./waste_quality_logo.png": 7319
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81324;